<template>
    <div>
        <v-btn id="tooltip" class="tooltip"></v-btn>
        <div class="div_imgXml" v-html="imgXml"></div>
    </div>
</template>

<script>
import mixinCarImage from './mixinXMLImage';

export default {
    mixins: [mixinCarImage],

    props: {
        imgXml: { type: String, required: true }
    },

    methods: {
        // will be called from parent with $refs
        highlightItem(itemId) {
            // ids can be s1-1. the id itself is the first s1, we we want to exclude the -1 in case it exists
            const elementSelector = `[id*="${itemId}"]:not([id*="-${itemId}"])`;
            window.linkIDs(this.$el, elementSelector)
        },
        // will be called from parent with $refs
        unlightItem(itemId) {
            const elementSelector = `[id*="${itemId}"]:not([id*="-${itemId}"])`;
            window.unlinkIDs(this.$el, elementSelector)
        }
    },

    mounted() {
        window.linkIDs = function(element, elementSelector = '') {
            const imageElement = element.querySelectorAll(`${elementSelector} rect, ${elementSelector} path, ${elementSelector} polygon`);
            imageElement.forEach(element => {
                element.style.fill = this.mixinHoverColor;
                element.style.opacity = this.mixinHoverOpacity;
            });
            this.$emit('item-hovered', element.id.split('-')[0].substring(2))
        }.bind(this);

        window.unlinkIDs = function(element, elementSelector = '') {
            const imageElement = element.querySelectorAll(`${elementSelector} rect, ${elementSelector} path, ${elementSelector} polygon`);
            imageElement.forEach(element => {
                element.style.fill = 'unset';
                element.style.opacity = 0;
            });
            this.$emit('item-hovered-out', element.id.split('-')[0].substring(2))
        }.bind(this);
    },
    beforeDestroy() {
        delete window.linkIDs;
        delete window.unlinkIDs;
    }
};
</script>

<style lang="scss" scoped>
.tooltip {
    padding: 4px 6px;
    z-index: 1000;
}

.div_imgXml {
    margin: 0 auto;
    width: 100%;
    background: white;
    border-radius: 18px;
    overflow: hidden;
}
</style>
